// ログイン画面にて読み込まれるTypeScript

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
// 読み込むとコンパイルエラーとなるためコメントアウト
// import "channels";

Rails.start();
ActiveStorage.start();

// import the bootsrap library.
import 'bootstrap';

import '../scss/login.scss';

// 旧`app/assets/javascripts/common.js`, いくつかのフロントエンド処理に利用
// FIXME: （技術的負債でもあるので）このファイル読み込みをなくしたい（bootstrap等の外部ライブラリを利用するなど）
import '../common';
